import CryptoJS from "crypto-js";

export const decrypt = (ciphertext, key = "LDS") => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const encrypt = (text, key = "LDS") => {
  // 保留原密文字节，仅使用无需 URL 转义的 Base64URL 表示。
  return CryptoJS.AES.encrypt(String(text), key)
    .toString()
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const normalizeRouteParam = (value) => {
  const text = String(value || "");
  if (!text) return "";
  try {
    return encodeURIComponent(decodeURIComponent(text));
  } catch (error) {
    return encodeURIComponent(text);
  }
};

export const decryptRouteParam = (ciphertext, key = "LDS") => {
  let text = String(ciphertext || "");
  if (!text) return "";
  try {
    // 兼容已发出的旧链接及转发时多编码一次的参数，限制解码次数。
    for (let i = 0; i < 2 && text.includes("%"); i++) {
      text = decodeURIComponent(text);
    }
    const base64 = text.replace(/-/g, "+").replace(/_/g, "/");
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(base64) || base64.length % 4 === 1) {
      return "";
    }
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const payload = CryptoJS.enc.Base64.parse(padded);
    // 标准 OpenSSL 格式：Salted__ + 8 字节盐 + 完整 AES 密文块。
    if (
      payload.sigBytes < 32 ||
      payload.sigBytes % 16 !== 0 ||
      payload.words[0] !== 0x53616c74 ||
      payload.words[1] !== 0x65645f5f ||
      CryptoJS.enc.Base64.stringify(payload) !== padded
    ) {
      return "";
    }
    return decrypt(padded, key);
  } catch {
    // 非法 URI 或损坏密文沿用调用页面的空结果处理，不中断页面加载。
    return "";
  }
};

/**
 *
 * @param component Component to be registered
 * @param alias Component alias
 * @returns any
 */
export const withInstall = (component, alias) => {
  const comp = component;
  comp.install = (app) => {
    app.component(comp.name || comp.displayName, component);
    if (alias) {
      app.config.globalProperties[alias] = component;
    }
  };
  return component;
};

/**
 * @param str String in camelCase to convert to snake_case
 * @returns String in snake_case
 */
export const humpToUnderline = (str) => {
  return str.replace(/([A-Z])/g, "-$1").toLowerCase();
};

/**
 * @param str String in snake_case to convert to camelCase
 * @returns String in camelCase
 */
export const underlineToHump = (str) => {
  if (!str) return "";
  return str.replace(/\-(\w)/g, (_, letter) => {
    return letter.toUpperCase();
  });
};

/**
 * Convert camelCase to dash-separated
 */
export const humpToDash = (str) => {
  return str.replace(/([A-Z])/g, "-$1").toLowerCase();
};

export const setCssVar = (prop, val, dom = document.documentElement) => {
  dom.style.setProperty(prop, val);
};

export const getCssVar = (prop, dom = document.documentElement) => {
  return getComputedStyle(dom).getPropertyValue(prop);
};

/**
 * Find the index of an item in an array of objects
 * @param {Array} ary The array to search
 * @param {Function} fn The function to determine the match
 */
export const findIndex = (ary, fn) => {
  if (ary.findIndex) {
    return ary.findIndex(fn);
  }
  let index = -1;
  ary.some((item, i, ary) => {
    const ret = fn(item, i, ary);
    if (ret) {
      index = i;
      return ret;
    }
  });
  return index;
};

export const trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
};

/**
 * @param {Date | number | string} time The time to format
 * @param {String} fmt The format to use, e.g., yyyy-MM-dd, yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return "";
  else {
    const date = new Date(time);
    const o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (const k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return fmt;
  }
}

/**
 * Generate a random string
 */
export function toAnyString() {
  const str = "xxxxx-xxxxx-4xxxx-yxxxx-xxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString();
  });
  return str;
}

/**
 * Capitalize the first letter
 */
export function firstUpperCase(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
}

/**
 * Convert object to FormData
 */
export function objToFormData(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key]);
  });
  return formData;
}
